import React, { useEffect, useState } from 'react';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import './MeteoData.css';

function MeteoAlarmas(props) {
    var getBrowserWidth = function () {

        if (window.innerWidth < 1023) {
            return "xs";
        }

    };

    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    var idDevice = (JSON.parse(sessionStorage.getItem("MeteoConfiguration"))[0].idDevice);
    const { code, ct, inv } = props;
    /*const params = useParams();
    const { ct, inv } = params;*/
    const [filtrarActivas, setFiltrarActivas] = useState(false);
    var [textoBotonActivas, setTextoBotonActivas] = useState('Mostrar solo activas');
    var [INV, setINV] = useState([]);
    var [activas, setActivas] = useState(0);
    var [filas, setFilas] = useState([]);
    let number = 0;

    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/inverters?idSolarFarm=" + idParque+"&idDevice="+idDevice, { method: 'GET', credentials: 'include' })
            .then(async (dataINV) => { setINV(await dataINV.json()); })
            .catch(e => { console.log(e); })
        sessionStorage.setItem("ct", ct);
        sessionStorage.setItem("inv", inv);
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key") && ct == sessionStorage.getItem("ct") && inv == sessionStorage.getItem("inv")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/inverters?idSolarFarm=" + idParque, { method: 'GET', credentials: 'include' })
                    .then(async (dataINV) => { setINV(await dataINV.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number, ct, inv]);

    function botonFiltrarActivas() {
        if (textoBotonActivas === 'Mostrar solo activas') {
            setTextoBotonActivas('Mostrar todo');
            setFiltrarActivas(true);
        } else {
            setTextoBotonActivas('Mostrar solo activas');
            setFiltrarActivas(false);
        }
    };

    /*Tamaño para las columnas de la tabla y cuatas filas de alarmas queremos*/
    var anchoPantalla, columnasTabla, ocupadoPorcentaje, pixelesOcupados, pixelesRestantes, tamañoColum, tamColumPeque, tamañoDescri, tamañoFechas;
    var filas_alarmas;

    if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
        /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
        anchoPantalla = window.screen.width;
        columnasTabla = 7;
        ocupadoPorcentaje = 30;
        pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
        pixelesRestantes = anchoPantalla - pixelesOcupados;
        tamañoColum = (pixelesRestantes / columnasTabla) - 1.1;
        tamColumPeque = tamañoColum / 2;
        tamañoDescri = tamañoColum + (tamColumPeque * 3);
        tamañoFechas = tamañoColum + (tamColumPeque / 2);
        filas_alarmas = 12;
    } else {
        /*Tamaño para las columnas de la tabla, si es en movil o tablet*/
        tamañoColum = 100;
        tamColumPeque = 90;
        tamañoDescri = 320;
        tamañoFechas = 160;
        filas_alarmas = 7;
    }

    /**Controlar el reajuste de tamaño de pantalla */
    window.addEventListener("resize", () => {
        if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
            /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
            anchoPantalla = window.screen.width;
            columnasTabla = 7;
            ocupadoPorcentaje = 30;
            pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
            pixelesRestantes = anchoPantalla - pixelesOcupados;
            tamañoColum = (pixelesRestantes / columnasTabla) - 1.1;
            tamColumPeque = tamañoColum / 2;
            tamañoDescri = tamañoColum + (tamColumPeque * 2);
            tamañoFechas = tamañoColum + (tamColumPeque / 2);
            filas_alarmas = 12;
        } else {
            /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
            tamañoColum = 100;
            tamColumPeque = 90;
            tamañoDescri = 320;
            tamañoFechas = 160;
            filas_alarmas = 7;
        }
    });
    var mobil = getBrowserWidth();
    var columnas;
    if (mobil === "xs") {
        columnas = [
        { field: "dispositivo", headerName: "Dispositivo", width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'celda-alarma-dispositivo' },
        { field: 'alarma', headerName: 'Alarma', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'celda-alarma' },
        { field: 'severidad', headerName: 'Severidad', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'celda-severidad' },
        { field: 'descripcion', headerName: 'Descripción', width: tamañoDescri, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'celda-alarma-descripcion' },
        { field: 'estado', headerName: 'Estado', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'celda-alarma-estado' },
        { field: 'inicio', headerName: 'Fecha Inicio', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'celda-alarma-inicio' },
        { field: 'fin', headerName: 'Fecha Fin', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'celda-alarma-fin' }];
    } else {
        columnas = [
        { field: "dispositivo", headerName: "Dispositivo", width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center' },
        { field: 'alarma', headerName: 'Alarma', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center' },
        { field: 'severidad', headerName: 'Severidad', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center' },
        { field: 'descripcion', headerName: 'Descripción', width: tamañoDescri, headerClassName: 'super-app-theme--header', headerAlign: 'center' },
        { field: 'estado', headerName: 'Estado', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center' },
        { field: 'inicio', headerName: 'Fecha Inicio', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center' },
        { field: 'fin', headerName: 'Fecha Fin', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center' }];
    }
    /*Mapeado de las alarmas */
    useEffect(() => {
        var array = [];
        var activas_aux = 0;
        INV.map((datoINV) => {
            const { id, name, alarm, severity, active, description, startDate, endDate } = datoINV;
            var auxState;
                if (active === true) { //Cambiar el true por activa y el false por inactiva
                    auxState = "Activa";
                    activas_aux++;
                } else {
                    auxState = "Inactiva";
                }
            
                array.push({ id: id, dispositivo: name, alarma: alarm, severidad: severity, descripcion: description, estado: auxState, inicio: startDate, fin: endDate });
        })
        if (filtrarActivas === true) {
            array = array.filter(a => { return a.estado === "Activa" });
        }
        setFilas(array.reverse()); //Queremos que las mas nuevas aparezcan antes
        setActivas(activas_aux);
    }, [INV, filtrarActivas]);
    if (mobil === "xs") {
        return (
            <div className='container-fluid' style={{ marginTop: '10px' }}>
                <div className='row'>
                    <div className='col'>
                        <div className='row'>
                            <div className='col-auto'>
                                <h5>Alarmas</h5>
                            </div>
                            <div className='col-auto'>
                                Activas: <strong>{activas}</strong>
                            </div>
                            <div className='col-auto'>
                                <a className='active-meteo-button' onClick={botonFiltrarActivas}>{textoBotonActivas}</a>
                            </div>
                            <div className='row' style={{ margin: 0, padding: 0 }}>
                                <div className='col' id='div-table-alarms-inv'>
                                    <DataGridPro sx={{
                                        width: '100%',
                                        align: 'center',
                                        ".MuiDataGrid-columnHeaders": { overflowX: 'scroll' },
                                        ".MuiDataGrid-virtualScroller": { marginTop: '56px !important' },
                                        ".MuiDataGrid-row": { display: 'block', width: '100% !important', paddingLeft: '5%', marginLeft: '0%' },
                                        ".MuiDataGrid-virtualScrollerContent": { width: 'auto !important' },
                                        ".MuiDataGrid-virtualScrollerRenderZone": { width: ' -webkit-fill-available' },
                                        ".MuiDataGrid-main": { overflow: 'none', },
                                        ".MuiDataGrid-cell": { width: 'fit-content', border: 'none', position: 'relative', paddingLeft: '35%', marginTop: '0.5%' },
                                        '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                                        '& .super-app-theme--Activa': { color: 'red' },
                                        '& .super-app-theme--Inactiva': { color: 'green', }
                                    }}
                                        rows={filas} columns={columnas} pagination pageSize={5} autoHeight={true} /*checkboxSelection*/
                                        componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "Alarmas" } } }}
                                        components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick disableColumnResize='true'
                                        getRowHeight={() => 'auto'}
                                        getRowClassName={(params) => `super-app-theme--${params.row.estado}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className='container-fluid' style={{ marginTop: '10px' }}>
                <div className='row'>
                    <div className='col'>
                        <div className='row'>
                            <div className='col-auto'>
                                <h5>Alarmas</h5>
                            </div>
                            <div className='col-auto'>
                                Activas: <strong>{activas}</strong>
                            </div>
                            <div className='col-auto'>
                                <a className='active-meteo-button' onClick={botonFiltrarActivas}>{textoBotonActivas}</a>
                            </div>
                            <div className='row' style={{ margin: 0, padding: 0 }}>
                                <div className='col' id='div-table-alarms-inv'>
                                    <DataGridPro sx={{
                                        width: '100%',
                                        '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                                        '& .super-app-theme--Activa': { color: 'red' },
                                        '& .super-app-theme--Inactiva': { color: 'green', }
                                    }}
                                        rows={filas} columns={columnas} pagination pageSize={11} autoHeight={true}
                                        components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick
                                        componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "AlarmasINV" + ct + "-" + inv } } }}
                                        getRowClassName={(params) => `super-app-theme--${params.row.estado}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default MeteoAlarmas